import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';

// Material Modules
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTabsModule} from '@angular/material/tabs';

// Shared Modules
import {SharedPipesModule} from '../../pipes/shared-pipes.module';
import {SharedDirectivesModule} from '../../directives/shared-directives.module';
import {MaterialCommonModule} from '../../material-modules/material-common.module';
import {SharedComponentsModule} from '../shared/shared-components.module';

// Components
import {ArquivoExtratoComponent} from './arquivo-extrato.component';
import {ArquivoExtratoFileInputComponent} from './importar-arquivo/arquivo-extrato-file-input.component';
import {ImportarArquivoDialogComponent} from './importar-arquivo-dialog/importar-arquivo-dialog.component';
import {AssociarLinhasComponent} from './associar-linhas/associar-linhas.component';
import {
    SelecionarConjuntoCategoriaContabilDialogComponent
} from './associar-linhas/selecionar-conjunto-categoria-contabil-dialog/selecionar-conjunto-categoria-contabil-dialog.component';
import {
    CadastrarConjuntoCategoriaContabilDialogComponent
} from './associar-linhas/cadastrar-conjunto-categoria-contabil-dialog/cadastrar-conjunto-categoria-contabil-dialog.component';
import {
    EscolherTipoAssociacaoDialogComponent
} from './associar-linhas/escolher-tipo-associacao-dialog/escolher-tipo-associacao-dialog.component';
import {ErroImportacaoDialogComponent} from './erro-importacao-dialog/erro-importacao-dialog.component';

// Services
import {ArquivoExtratoService} from '../../services/arquivo-extrato/arquivo-extrato.service';
import {LoadingPopupService} from 'src/app/services/loadingPopup/loading-popup.service';
import {ArquivoExtratoRoutingModule} from './arquivo-extrato-routing.module';

@NgModule({
    declarations: [
        ArquivoExtratoComponent,
        ArquivoExtratoFileInputComponent,
        ImportarArquivoDialogComponent,
        AssociarLinhasComponent,
        SelecionarConjuntoCategoriaContabilDialogComponent,
        CadastrarConjuntoCategoriaContabilDialogComponent,
        EscolherTipoAssociacaoDialogComponent,
        ErroImportacaoDialogComponent
    ],
    imports: [
        CommonModule,
        ArquivoExtratoRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        FlexLayoutModule,

        // Material Modules
        MatToolbarModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatSelectModule,
        MatCheckboxModule,
        MatTabsModule,

        // Shared Modules
        SharedPipesModule,
        SharedDirectivesModule,
        MaterialCommonModule,
        SharedComponentsModule
    ],
    providers: [
        ArquivoExtratoService,
        LoadingPopupService
    ],
    exports: [
        ArquivoExtratoComponent,
        ArquivoExtratoFileInputComponent,
        ImportarArquivoDialogComponent,
        AssociarLinhasComponent
    ]
})
export class ArquivoExtratoModule {
}
